export default "/images/vendor/flag-icon-css/flags/1x1/tn.svg?2b1d5aa34ddb2dc385c32ee84ccefd65";